// This file was generated and should not be edited
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var IconMedBioTopoStatic_1;
import { html } from 'lit';
import { customElement } from 'lit/decorators.js';
import { IconBaseElement } from '../base/icon-base.component';
const _s24IconSvg = html `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M14 6C14 7.10457 13.1046 8 12 8 10.8954 8 10 7.10457 10 6 10 4.89543 10.8954 4 12 4 13.1046 4 14 4.89543 14 6ZM12 20C13.1046 20 14 19.1046 14 18 14 16.8954 13.1046 16 12 16 10.8954 16 10 16.8954 10 18 10 19.1046 10.8954 20 12 20ZM18.1962 10.732C17.2396 11.2843 16.0164 10.9566 15.4641 10 14.9118 9.04341 15.2396 7.82023 16.1962 7.26794 17.1528 6.71566 18.3759 7.04341 18.9282 8 19.4805 8.95658 19.1528 10.1798 18.1962 10.732ZM5.07179 16C5.62407 16.9566 6.84725 17.2843 7.80384 16.732 8.76042 16.1798 9.08817 14.9566 8.53589 14 7.9836 13.0434 6.76042 12.7157 5.80384 13.2679 4.84725 13.8202 4.5195 15.0434 5.07179 16ZM16.1962 16.7321C15.2396 16.1798 14.9118 14.9566 15.4641 14 16.0164 13.0434 17.2396 12.7157 18.1962 13.268 19.1528 13.8203 19.4805 15.0434 18.9282 16 18.3759 16.9566 17.1528 17.2844 16.1962 16.7321ZM5.07179 7.99999C4.5195 8.95658 4.84725 10.1798 5.80384 10.732 6.76042 11.2843 7.9836 10.9566 8.53589 10 9.08817 9.04341 8.76042 7.82023 7.80384 7.26794 6.84725 6.71566 5.62407 7.04341 5.07179 7.99999Z" class="svg-bg"/>
  <path fill-rule="evenodd" clip-rule="evenodd" d="M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24ZM12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z" class="svg-bg"/>
</svg>
`;
/**
 * IconMedBioTopoStatic is a generated icon component.
 */
let IconMedBioTopoStatic = IconMedBioTopoStatic_1 = class IconMedBioTopoStatic extends IconBaseElement {
    render() {
        return html `${IconMedBioTopoStatic_1.icons.get(this.size)}`;
    }
};
/**
   * Defines which icon resource to use at which icon size
   */
IconMedBioTopoStatic.icons = new Map([
    ['s8', _s24IconSvg],
    ['s12', _s24IconSvg],
    ['s16', _s24IconSvg],
    ['s24', _s24IconSvg],
    ['s32', _s24IconSvg],
    ['s40', _s24IconSvg],
    ['s48', _s24IconSvg],
    ['s64', _s24IconSvg],
    ['s72', _s24IconSvg],
    ['s80', _s24IconSvg],
]);
IconMedBioTopoStatic = IconMedBioTopoStatic_1 = __decorate([
    customElement('zui-icon-med-bio-topo-static')
], IconMedBioTopoStatic);
export { IconMedBioTopoStatic };
